
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getWorkorderpaymentTypes = async () => {
  return await get<ApiResponse<any[]>>("/workorderpaymentTypes").then((res)=>{
      return res
    })
};

 